<template>
  <div class="checkout-page">
    <div class="container">
      <!-- 步驟指示器 -->
      <div class="steps">
        <div class="step end">
          <div class="step-number">1</div>
          <span>確認商品</span>
        </div>
        <div class="step end">
          <div class="step-number">2</div>
          <span>填寫資料</span>
        </div>
        <div class="step active">
          <div class="step-number">3</div>
          <span>訂單成立</span>
        </div>
      </div>

      <!-- 主要內容區 -->
      <div class="checkout-grid">
        <!-- 主要內容 -->
        <div class="main-content">
          <div class="card">
            <h2>訂單資訊</h2>
            <div class="order-info">
              <div class="info-row">
                <span class="info-label">訂單編號：</span>
                <span class="info-value order-number">{{ orderNumber }}</span>
              </div>
              <div class="info-row">
                <span class="info-label">訂單日期：</span>
                <span class="info-value">{{ orderDate }}</span>
              </div>
              <div class="info-row">
                <span class="info-label">訂單狀態：</span>
                <span class="info-value order-status">{{ orderStatus }}</span>
              </div>
            </div>

            <div class="success-message">
              <i class="fas fa-check-circle"></i>
              <h3>訂單已建立成功</h3>
              <p>感謝您的訂購！我們會盡快為您處理訂單。</p>
            </div>
          </div>
        </div>

        <!-- 右側：動作按鈕 -->
        <div class="sidebar">
          <div class="card">
            <div class="btn-group">
              <button class="btn btn-primary" @click="continueShopping">
                繼續購物
              </button>
              <button class="btn btn-secondary" @click="goToDashboard">
                查看訂單
              </button>
            </div>
          </div>

          <!-- 客服聯絡 -->
          <div class="card">
            <h3>需要協助？</h3>
            <div class="contact-info">
              <div class="contact-item">
                <i class="fas fa-phone"></i>
                <span>客服電話：(07) 803-3324</span>
              </div>
              <div class="contact-item">
                <i class="fas fa-envelope"></i>
                <span>客服信箱：annyoohoh@gmail.com</span>
              </div>
            </div>

            <!-- ⬅️ 加入 Line 客服 -->
            <div class="line-connect">
              <h3>Line 客服</h3>
              <div class="line-id">@annyoohoh</div>
              <a
                href="https://lin.ee/jrA7vQO"
                target="_blank"
                class="line-button"
              >
                <i class="fab fa-line"></i> 加入好友
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script src="@/assets/js/order" defer></script>

<style scoped src="@/assets/css/order.css"></style>
